export const common = {
	finalizeApplication: {
		sv: "Skicka in",
	},
	deleteApplication: {
		sv: "Ta bort ansökan",
	},
	change: {
		sv: "Ändra",
	},
	remove: {
		sv: "Ta bort",
	},
	abort: {
		sv: "Avbryt",
	},
	okContinue: {
		sv: "Okej, fortsätt",
	},
	ok: {
		sv: "Okej",
	},
	goBack: {
		sv: "Tillbaka",
	},
	continue: {
		sv: "Fortsätt",
	},
	choose: {
		sv: "Välj {0}",
	},
	moreAbout: {
		sv: "Mer om {0}",
	},
	chosen: {
		sv: "Vald",
	},
	you: {
		sv: "(du)",
	},
	sekPerMonth: {
		sv: "kr/mån",
	},
	perMonth: {
		sv: "/mån",
	},
	monthShort: {
		sv: "mån",
	},
	from: {
		sv: "Från",
	},
	save: {
		sv: "Spara",
	},
	search: {
		sv: "Sök",
	},
	noName: {
		sv: "namn saknas",
	},
	isCurrentUser: {
		sv: "(du)",
	},
	ssnFormat: {
		sv: "ÅÅÅÅMMDD-XXXX",
	},
	dateFormat: {
		sv: "ÅÅÅÅ-MM-DD",
	},
	close: {
		sv: "Stäng",
	},
	readMore: {
		sv: "Läs mer",
	},
	bankUrl: {
		sv: "https://bank.svea.com/",
	},
	logout: {
		sv: "Logga ut",
	},
	noResults: {
		sv: "Inga resultat",
	},
	email: {
		sv: "Mejladress",
	},
	confirm: {
		sv: "Bekräfta",
	},
};
